const PLATFORM_HOSTS = {
  google_meet: [
    /(?:^|\.)meet\.google\.com$/i,
    /(?:^|\.)hangouts\.google\.com$/i,
  ],
  microsoft_teams: [
    /(?:^|\.)teams\.microsoft\.com$/i,
    /(?:^|\.)teams\.live\.com$/i,
    /(?:^|\.)teams\.cloud\.microsoft$/i,
  ],
  zoom: [/(?:^|\.)zoom\.us$/i, /(?:^|\.)zoom\.com$/i, /(?:^|\.)zoomgov\.com$/i],
};

const PLATFORM_PATHS = {
  google_meet: [
    /^\/[a-z]{3}-[a-z]{4}-[a-z]{3}\/?$/i,
    /^\/lookup\//i,
    /^\/landing/i,
    /^\/[a-z0-9-]+\/[a-z0-9-]+/i,
  ],
  microsoft_teams: [
    /meetup-join/i,
    /^\/l\//i,
    /^\/meet\//i,
    /^\/_#\/l\//i,
    /meetingjoin/i,
  ],
  zoom: [/^\/j\/\d+/i, /^\/s\/\d+/i, /^\/w\//i, /^\/my\//i, /^\/meeting\//i],
};

export const EXTERNAL_MEETING_PLATFORMS = [
  'google_meet',
  'microsoft_teams',
  'zoom',
  'other',
];

export const normalizeMeetingUrl = raw => {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

export const parseMeetingUrl = raw => {
  const normalized = normalizeMeetingUrl(raw);
  if (!normalized) return null;

  try {
    return new URL(normalized);
  } catch (error) {
    return null;
  }
};

const hostMatches = (hostname, patterns) =>
  patterns.some(pattern => pattern.test(hostname));

const pathMatches = (pathname, search, patterns) => {
  const value = `${pathname}${search}`;
  return patterns.some(pattern => pattern.test(pathname) || pattern.test(value));
};

const isUsableMeetingUrl = parsed =>
  Boolean(parsed?.hostname && parsed.hostname.includes('.'));

export const detectMeetingPlatform = raw => {
  const parsed = parseMeetingUrl(raw);
  if (!isUsableMeetingUrl(parsed)) return null;

  const known = Object.keys(PLATFORM_HOSTS).find(platform => {
    if (!hostMatches(parsed.hostname, PLATFORM_HOSTS[platform])) return false;
    return pathMatches(parsed.pathname, parsed.search, PLATFORM_PATHS[platform]);
  });

  return known || 'other';
};

export const isValidMeetingLink = (raw, platform = null) => {
  const detected = detectMeetingPlatform(raw);
  if (!detected) return false;
  if (!platform || platform === 'other') return true;
  return detected === platform;
};

export const meetingLinkValidationError = (raw, platform = null) => {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return 'required';

  const parsed = parseMeetingUrl(trimmed);
  if (!isUsableMeetingUrl(parsed)) return 'invalid';

  const detected = detectMeetingPlatform(trimmed);
  if (!detected) return 'unrecognized';
  if (platform && platform !== 'other' && detected !== platform) return 'mismatch';
  return null;
};
